import { __assign, __read, __rest } from "tslib";
import { PROPERTIES_CONNECTOR } from '../../constants';
export var mergePropertiesGroup = function (propertiesGroup, mergeOrder) {
    var _a;
    var result = propertiesGroup.result, properties = __rest(propertiesGroup, ["result"]);
    var hasGroupedProperties = Object.keys(properties).length > 1;
    if (hasGroupedProperties) {
        var propertiesToGroup = mergeOrder ? mergeOrder : Object.keys(properties);
        var groupedProperties = propertiesToGroup.reduce(function (_a, key) {
            var _b = __read(_a, 2), currentKey = _b[0], currentValue = _b[1];
            var value = properties[key];
            var mergedValue = currentValue
                ? currentValue + " " + PROPERTIES_CONNECTOR + " " + value
                : value;
            var mergedKey = currentKey ? currentKey + "-" + key : key;
            return [mergedKey, mergedValue];
        }, []);
        var _b = __read(groupedProperties, 2), name_1 = _b[0], value = _b[1];
        return _a = {
                result: result
            },
            _a[name_1] = value,
            _a;
    }
    return __assign({ result: result }, properties);
};
